import React from 'react';
import Cube from './../Cube/Cube';
import HexaContainer from './../HexaContainer/HexaContainer';
import Navigation from './../Navigation/Navigation';
import styles from './Header.scss';

const headerStyle = {
    filter: 'blur(20px)',
    opacity: 0,
    overflow: 'hidden',
    willChange: 'filter, opacity',
}

export default class Header extends React.Component{
    constructor(props){
        super(props);

        this.toggleMenu = this.toggleMenu.bind(this);
    }

    state = {
        toggle: false,
    }

    toggleMenu(){
        const toggleStateOpen = !this.state.toggle
        this.setState({toggle: toggleStateOpen})
    }

    moveHeaderToBody(){
        const header = document.querySelector('.'+styles.header);
        document.body.prepend(header)
    }
    
    componentDidMount(){
        this.moveHeaderToBody()
    }
    
    render(){
        return(
            <header className={ this.state.toggle? styles.header + ' ' + styles.header_open : styles.header } style={headerStyle}>
                <HexaContainer elements={[
                    <Navigation key={'navigation'} callbackFn={this.toggleMenu} />, 
                    <Cube key={'cube'} interactive={true} callbackFn={this.toggleMenu} />
                ]} type={'header'} extraClass={styles.header_hexa} />
            </header>            
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Header/Header.js